<template>
  <CSidebar 
    :minimize="minimize"
    unfoldable
    dropdownMode="openActive"
    :show="show"

    @update:show="value => $store.dispatch('panel/set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <img alt="Leadgrease logo" name="logo" xw class="c-sidebar-brand-minimized leadgrease-logo-minimized" block src="@sset/logo.png" />
      <img alt="Leadgrease logo" class="w-75 img-fluid c-sidebar-brand-full" block src="@sset/leadgrease.png" />
    </CSidebarBrand>
    <SidebarOptions />
    <CSidebarMinimizer 
      class="c-d-md-down-none" 
      @click.native="$store.dispatch('panel/toggle', 'sidebarMinimize')"
    />
  </CSidebar>
</template>

<script>
import SidebarOptions from "./sidebarOptions";
import { mapGetters } from "vuex";

export default {
  components: {
    SidebarOptions
  },

  computed: {
    ...mapGetters({
      show: "panel/sidebarShow",
      minimize: "panel/sidebarMinimize"
    })
  }
};
</script>
<style lang="scss" scoped>
    .leadgrease-logo-minimized{
        height: 2rem;
        width: auto;
    }
</style>
